<template>
  <div id="gauges_container">
    <!-- Pop Vote -->
    <gauge-item
      category="Polling"
      link_to="/popular_vote_gauge"
      :title="gauges.pop_vote.settings.title"
      :value="gauges.pop_vote.value"
      :minValue="gauges.pop_vote.settings.minValue"
      :maxValue="gauges.pop_vote.settings.maxValue"
      :options="gauges.pop_vote.options"
      :decimalPlace="gauges.pop_vote.settings.decimalPlace"
      :unit="gauges.pop_vote.settings.unit"
    />
    <!-- Senate Control -->
    <gauge-item
      link_to="/senate_control_gauge"
      category="Polling"
      :title="gauges.senate_control.settings.title"
      :value="gauges.senate_control.value"
      :minValue="gauges.senate_control.settings.minValue"
      :maxValue="gauges.senate_control.settings.maxValue"
      :options="gauges.senate_control.options"
      :decimalPlace="gauges.senate_control.settings.decimalPlace"
      :unit="gauges.senate_control.settings.unit"
    />
    <!--  Generic Ballot-->
    <gauge-item
      link_to="/generic_ballot_gauge"
      category="Polling"
      :title="gauges.generic_ballot.settings.title"
      :value="gauges.generic_ballot.value"
      :minValue="gauges.generic_ballot.settings.minValue"
      :maxValue="gauges.generic_ballot.settings.maxValue"
      :options="gauges.generic_ballot.options"
      :decimalPlace="gauges.generic_ballot.settings.decimalPlace"
      :unit="gauges.generic_ballot.settings.unit"
    />
    <!-- Betting: WH-->
    <gauge-item
      link_to="/betting_markets"
      category="Betting Markets"
      category_class="betting_markets"
      :title="gauges.betting_wh.settings.title"
      :value="gauges.betting_wh.value"
      :minValue="gauges.betting_wh.settings.minValue"
      :maxValue="gauges.betting_wh.settings.maxValue"
      :options="gauges.betting_wh.options"
      :decimalPlace="gauges.betting_wh.settings.decimalPlace"
      :unit="gauges.betting_wh.settings.unit"
    />
    <!-- Betting: Senate-->
    <gauge-item
      link_to="/betting_markets"
      category="Betting Markets"
      category_class="betting_markets"
      :title="gauges.betting_senate.settings.title"
      :value="gauges.betting_senate.value"
      :minValue="gauges.betting_senate.settings.minValue"
      :maxValue="gauges.betting_senate.settings.maxValue"
      :options="gauges.betting_senate.options"
      :decimalPlace="gauges.betting_senate.settings.decimalPlace"
      :unit="gauges.betting_senate.settings.unit"
    />
    <!-- Betting: House -->
    <gauge-item
      category="Betting Markets"
      link_to="/betting_markets"
      category_class="betting_markets"
      :title="gauges.betting_house.settings.title"
      :value="gauges.betting_house.value"
      :minValue="gauges.betting_house.settings.minValue"
      :maxValue="gauges.betting_house.settings.maxValue"
      :options="gauges.betting_house.options"
      :decimalPlace="gauges.betting_house.settings.decimalPlace"
      :unit="gauges.betting_house.settings.unit"
    />
    <!-- Models -->
    <gauge-item
      category="Models"
      link_to="/538_model"
      category_class="models"
      :title="gauges.models_538.settings.title"
      :value="gauges.models_538.value"
      :minValue="gauges.models_538.settings.minValue"
      :maxValue="gauges.models_538.settings.maxValue"
      :options="gauges.models_538.options"
      :decimalPlace="gauges.models_538.settings.decimalPlace"
      :unit="gauges.models_538.settings.unit"
    />
  </div>
</template>

<script>
import GaugeItem from "./Gauge";
import gauges_config from "./gauge_settings";

export default {
  name: "Gauges",
  components: { GaugeItem },
  props: ["external_news_data", "max_items", "clock"],
  data() {
    return {
      config: gauges_config,
      gauges: gauges_config
    };
  },
  created() {
    this.get_gauge_data();
  },
  methods: {
    get_gauge_data: async function() {
      this.gauges = Object.assign({}, this.config);
      let data_source_url = "/api/get_gauge_data";
      let data;
      try {
        const response = await fetch(data_source_url, { mode: "no-cors" });
        data = await response.json();
      } catch (e) {
        console.warn(
          `Error getting data from ${data_source_url}\n Error was: ${e}`
        );
      }
      let gauge_data = data.gauge_data;
      let cache_info = data.cache_info;
      if (gauge_data) {
        this.gauges.pop_vote.value = parseFloat(gauge_data["Gauges.pop_vote"]);
        this.gauges.senate_control.value = parseFloat(
          gauge_data["Gauges.Senate-Control"]
        );
        this.gauges.generic_ballot.value = parseFloat(
          gauge_data["Gauges.Generic-Ballot"]
        );
        this.gauges.betting_wh.value = parseFloat(
          gauge_data["Gauges.Betting:WH"]
        );
        this.gauges.betting_senate.value = parseFloat(
          gauge_data["Gauges.Betting:Senate-Control"]
        );
        this.gauges.betting_house.value = parseFloat(
          gauge_data["Gauges.Betting:House-Control"]
        );
        this.gauges.models_538.value = parseFloat(
          gauge_data["Gauges.538-Model"]
        );
      }
    },
    beforeCreate() {
      this.gauges = Object.assign({}, this.gauges_config);
    }
  }
};
</script>

<style scoped>
#gauges_container {
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
  /*  background-color: slategray; */
  /* color: white; */
  background-color: gainsboro;
  color: white;
}
</style>
